/* eslint-disable factorial/no-raw-html */
import { useState } from 'react'

import { Box, Text, dimensions } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'

import { useEffect } from 'modules/core/hooks/useEffect'

import './index.styles.css'
type Variant = 'base' | 'launch'

interface Props {
  buttons?: React.ReactNode
  canBeClosed?: boolean
  contentStyle?: Partial<CSSStyleDeclaration>
  description: string
  image: string
  title: string
  variant?: Variant
  visible?: boolean
  onClose?: () => void
}

export const AnnouncementBanner = ({
  buttons,
  canBeClosed,
  description,
  image,
  variant = 'base',
  visible = true,
  title,
  onClose,
}: Props) => {
  const [isVisible, setIsVisible] = useState(visible)

  useEffect(() => {
    setIsVisible(visible)
  }, [visible])

  if (!isVisible) return null

  return (
    <Box>
      <Box className={`AnnouncementBanner_wrapperVariant_${variant}`}>
        <Box width="s360">
          <img src={image} height="180" className={`AnnouncementBanner_imageVariant_${variant}`} />
        </Box>

        <Box className={'AnnouncementBanner_content'}>
          <Box height="full" flexDirection="row">
            <Box maxWidth="s600" flexDirection="column" justifyContent="spaceBetween" gap="s8">
              <Box gap="s8">
                <Text.Normal size="300" weight="semibold" color="grey1000">
                  {title}
                </Text.Normal>
                <Text.Normal size="200" color="textSecondary">
                  {description}
                </Text.Normal>
              </Box>

              {buttons && <Box className={'AnnouncementBanner_buttons'}>{buttons}</Box>}
            </Box>
          </Box>
        </Box>
        {canBeClosed && (
          <Box position="absolute" style={{ top: dimensions.s16, right: dimensions.s16 }}>
            <F0Icon
              icon={Cross}
              size="lg"
              color="bold"
              cursor="pointer"
              onClick={() => {
                setIsVisible(false)
                onClose?.()
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
